import { render } from "./SupportContact.vue?vue&type=template&id=272442ac&scoped=true"
import script from "./SupportContact.vue?vue&type=script&lang=js"
export * from "./SupportContact.vue?vue&type=script&lang=js"

import "./SupportContact.vue?vue&type=style&index=0&id=272442ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272442ac"]])

export default __exports__